
export default {
  name: 'InviteYourTeamSvg',
};
